import { CircleAlert, Info, TriangleAlert, type LucideIcon } from "lucide-react";

import type { AlertSeverity } from "../types/alerts";

const ICONS: Record<AlertSeverity, LucideIcon> = {
  extreme: TriangleAlert,
  severe: TriangleAlert,
  moderate: CircleAlert,
  minor: Info,
  unknown: Info,
};

const COLOUR_CLASSES: Record<AlertSeverity, string> = {
  extreme: "text-error",
  severe: "text-error",
  moderate: "text-alert-moderate",
  minor: "text-on-surface-variant",
  unknown: "text-on-surface-variant",
};

interface Props {
  severity: AlertSeverity;
  size?: number;
}

export default function AlertSeverityIcon({ severity, size = 20 }: Props) {
  const Icon = ICONS[severity];
  return <Icon size={size} aria-hidden className={COLOUR_CLASSES[severity]} />;
}
